import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";
// import { store} from '../store'
import { saveUserToIndexedDB, saveProfileToIndexedDB } from "../../storage/profileStorage";
import { RegistrationStatus } from "../../common/enum";
// import {store} from "../store";

export const logout = createAsyncThunk(
  "auth/logout",
  async function (_payload, thunkAPI) {
      thunkAPI.dispatch({ type: 'logout/LOGOUT' });
  }
);

export const register = createAsyncThunk(
  "auth/register",
  async ({ data }, { rejectWithValue }) => {
    try {
      const rsp = await API.register(data);
      return rsp.data;
    } catch (error) {
//console.log(error);
      throw error;
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ data }, { rejectWithValue }) => {
    try {
      const rsp = await API.postDataApi(
        `Registration/ResetPassword?newPassword=${encodeURIComponent(data.password)}&resetToken=${data.resetToken}&status=${data.status}&name=${data.name}`
      );
      return rsp.data;
    } catch (error) {
     // console.log(error);
      throw error;
    }
  }
);

// export const ValidateResetToken = createAsyncThunk(
//   "auth/ValidateResetToken",
//   async (token, { rejectWithValue }) => {
//     try {
//       const response = await API.getDataApi(
//         `/ValidateResetToken?token=${token}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

export const ValidateResetToken = createAsyncThunk(
 "auth/ValidateResetToken",
  async (tokenValidate, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

        const res = await API.getApi(
      `Registration/ValidateResetToken`,
      { token: tokenValidate }
    );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const VerificationEmail = createAsyncThunk(
  "auth/verificationEmail",
  async ({ data }, { rejectWithValue }) => {
    try {
      const rsp = await API.postDataApi(
        `Registration/VerificationEmail?verificationToken=${data.verificationToken}&status=${data.status}`
      );
      return rsp.data;
    } catch (error) {
     // console.log(error);
      throw error;
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async ({ data }, { rejectWithValue }) => {
    try {
      const url = "Registration/ForgotPassword";
      const params = {
        email: data.email,
      };
      const rsp = await API.postApi(url, {}, params, "");
      return rsp.data;
    } catch (error) {
     // console.log(error);
      throw error;
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async ({ data }, { getState, dispatch }) => {
    try {
      const response = await API.login(data);
      if (response.status !== 200) {
        const msg = response.data.messgae || "Login Failed";
        throw new Error(msg);
      }

      return response.data;
    } catch (error) {
      // let error: AxiosError<ValidationErrors> = err // cast the error for access
      throw error;
    } finally {
      const { auth } = await getState();
      const { userId } = auth.user || {};
      if (userId) {
        dispatch(getUserEntity(userId));
      }
    }
  }
);

export const getUserEntity = createAsyncThunk(
  "auth/getUserEntity",
  async (userId, { getState }) => {
    try {
      const { auth } = await getState();
      const { token } = auth.user;
      const res = await API.getDataApi(
        `Registration/GetEntityDetailsById/${userId}`,
        token
      );

      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const checksEmailExist = createAsyncThunk(
  "auth/checksEmailExist",
  async (email, { getState }) => {
    try {
      const { auth } = await getState();
      const { token } = auth.user;
      const url = `Registration/CheckEmailExists`;
      const params = {
        email: email,
      };
      const res = await API.getApi(url, params, token);
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const CheckNIF = createAsyncThunk(
  "auth/CheckNIF",
  async (nif, { getState }) => {
    try {
      const { auth } = await getState();
      const { token } = auth.user;
      const url = `Registration/CheckNIF`;
      const params = {
        nif: nif,
      };
      const res = await API.getApi(url, params, token);
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);
export const CheckNome = createAsyncThunk(
  "auth/CheckNome",
  async (nome, { getState }) => {
    try {
      const { auth } = await getState();
      const { token } = auth.user;
      const url = `Registration/CheckNome`;
      const params = {
        nome: nome,
      };
      const res = await API.getApi(url, params, token);
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);
// export const logout = createAsyncThunk(
//     "auth/logout",
//     async ({data, navigate}, { rejectWithValue }) => {
//       await navigate('/');
//       return {};
//     }
//   );
export const addAddress = createAsyncThunk(
  "auth/addAddress",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.postDataApi("Registration/AddAddress", data, token);
      return rsp;
    } catch (error) {
      throw error;
    }
  }
);
export const addUserDetail = createAsyncThunk(
  "auth/addUserDetail",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.addUserDetail(data, token);
      return res;
    } catch (error) {
      throw error;
    }
  }
);

export const getChildEntitiesList = createAsyncThunk(
  "auth/getChildEntitiesList",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const { offset, limit, entityId } = data;
      const res = await API.postDataApi(
        `Registration/GetChildEntitiesList?offset=${offset}&limit=${limit}&parentEntityId=${entityId}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const getManagerInviteList = createAsyncThunk(
  "auth/getManagerInviteList",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const { offset, limit, id, status } = data;
      const res = await API.postDataApi(
        `Registration/GetInvite?offset=${offset}&limit=${limit}&entityPrimaryId=${id}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {},
    profile: {},
    loading: false,
    error: "",
    checksEmailExist: false,
    CheckNIF: false,
    CheckNome: false,
    identificationType: "",
    branchEntitiesCount: 0,
    branchEntitiesOffset: 0,
    branchEntitiesLimit: 20,
    branchEntities: [],
    branchEntitiesPage: 1,
    managerType: "",
    managerInviteCount: 0,
    managerInviteOffset: 0,
    managerInviteLimit: 20,
    managerInviteEntities: [],
    managerInvitePage: 1,
    managerRevokedPayload:{}
  },
  reducers: {
    // logout : ({user, ...rest}) => {
    //   return {
    //     user: {},
    //     ...rest,
    //   }
    // },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
    },
    setIdentitifcationType: (state, action) => {
      state.identificationType = action.payload;
    },
    setManagerType: (state, action) => {
      state.managerType = action.payload;
    },
    setBranchEntitiesOffset: (state, action) => {
      state.branchEntitiesOffset = action.payload;
    },
    setBranchEntitiesLimit: (state, action) => {
      state.branchEntitiesLimit = action.payload;
    },
    setBranchEntitiesPage: (state, action) => {
      state.branchEntitiesPage = action.payload;
    },
    setManagerInviteOffset: (state, action) => {
      state.managerInviteOffset = action.payload;
    },
    setManagerInviteLimit: (state, action) => {
      state.managerInviteLimit = action.payload;
    },
    setManagerInvitePage: (state, action) => {
      state.managerInvitePage = action.payload;
    },
    setManagerRevokedPayload: (state , action) => {
      state.managerRevokedPayload = action.payload;
    },
    saveUserData: (state , action) => {
      if (action.payload) {
        state.user=action.payload;
      }
    },
    saveEntityData: (state , action) => {
      if (action.payload) {
        state.profile = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.user) state.user = {};
        // state.user.token = action.payload.token;
        if (
          state.identificationType.length === 0 &&
          state.managerType.length === 0
        ) {
          state.user.userId = action.payload.userId;
          state.user.token = action.payload.token;
          state.user.status = RegistrationStatus.registering;
        }
        state.user.branchUserId = action.payload.userId;
      })
      .addCase(register.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.user) state.user = {};
        if (action.payload) {
          state.user.token = action.payload.token;
          state.user.userId = action.payload.userid;
          state.user.status = action.payload.status;
          state.user.entityId = action.payload.entityId;
          state.user.managerName = action.payload.managerName;
          state.user.managerEmail = action.payload.managerEmail;
          //localStorage.setItem("userData",JSON.stringify(state.user))
          saveUserToIndexedDB(JSON.stringify(state.user))
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(logout, (state) => {
        state.user = {};
      })
      .addCase(addAddress.pending, (state) => {
        state.loading = true;
      })
      .addCase(addAddress.fulfilled, (state) => {
        state.loading = false;
        // if (!state.user.address) state.user.address = {}
        // state.user.address = action.payload.
      })
      .addCase(addAddress.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload.message
      })
      .addCase(addUserDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUserDetail.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addUserDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(getUserEntity.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getUserEntity.fulfilled, (state, action) => {
        state.status = "idle";
        if (state.identificationType.length === 0) {
          state.profile = action.payload;
          //localStorage.setItem("entityProfile",JSON.stringify(state.profile))
          saveProfileToIndexedDB(JSON.stringify(state.profile))
        }
      })
      .addCase(getUserEntity.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(checksEmailExist.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(checksEmailExist.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.checksEmailExist = action.payload.success;
      })
      .addCase(checksEmailExist.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      }).addCase(CheckNIF.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(CheckNIF.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.checksEmailExist = action.payload.success;
      })
      .addCase(CheckNIF.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      }).addCase(CheckNome.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(CheckNome.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.checksEmailExist = action.payload.success;
      })
      .addCase(CheckNome.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(resetPassword.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(VerificationEmail.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(VerificationEmail.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(VerificationEmail.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
        .addCase(ValidateResetToken.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(ValidateResetToken.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(ValidateResetToken.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(forgotPassword.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(getChildEntitiesList.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getChildEntitiesList.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.branchEntities = action.payload.obj.entityDetailsLists;
        state.branchEntitiesCount = action.payload.obj.totalCount;
        // state.address = action.payload
      })
      .addCase(getChildEntitiesList.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.branchEntities = [];
        state.branchEntitiesCount = 0;
        state.branchEntitiesLimit = 20;
        state.branchEntitiesOffset = 0;
        state.branchEntitiesPage = 1;
      })
      .addCase(getManagerInviteList.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getManagerInviteList.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.managerInviteEntities = action.payload.obj.userInvites;
        state.managerInviteCount = action.payload.obj.totalCount;
        // state.address = action.payload
      })
      .addCase(getManagerInviteList.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.managerInviteEntities = [];
        state.managerInviteCount = 0;
        state.managerInviteLimit = 20;
        state.managerInviteOffset = 0;
        state.managerInvitePage = 1;
      });
  },
});
// export const getTokenFromStore = () => {
//   const { auth: { user: { token }}} = store.getState();
//   return token;
// }
export const {
  setIdentitifcationType,
  setBranchEntitiesOffset,
  setBranchEntitiesLimit,
  setBranchEntitiesPage,
  setManagerType,
  setManagerInviteOffset,
  setManagerInviteLimit,
  setManagerInvitePage,
  setManagerRevokedPayload,
  saveUserData,
  saveEntityData
} = authSlice.actions;

export const { clearAuth } = authSlice.actions;
export default authSlice.reducer;
